import { ChangeDetectionStrategy, Component, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { ItemsEmisionFacadeService } from './items-emision-facade.service';
import { CurrencyFormatPipe } from '../../../pipes/currency-format.pipe';
import { FieldErrorComponent } from '../../../shared/components/field-error/field-error.component';

@Component({
  selector: 'app-items-banner-web',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DatePickerModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    SelectModule,
    InputNumberModule,
    CurrencyFormatPipe,
    FieldErrorComponent
  ],
  templateUrl: './items-banner-web.component.html',
  styleUrls: ['./items-banner-web.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemsBannerWebComponent {
  @Input() readOnly: boolean = false;
  @Input() vigenciaDesde: Date | null = null;
  @Input() vigenciaHasta: Date | null = null;
  pricingDialogVisible = false;
  selectedTrace: any = null;

  readonly items = computed(() => this.facade.itemsByType().WEB_BANNER || []);
  readonly bonificadoOptions = [
    { label: 'No', value: false },
    { label: 'Sí', value: true }
  ];

  constructor(public facade: ItemsEmisionFacadeService) {}

  trackByRowId(index: number, item: { group: FormGroup; index: number }): string | number {
    return item.group.get('clientRowId')?.value ?? item.group.get('id')?.value ?? index;
  }

  handleRowKeydown(event: KeyboardEvent, index: number): void {
    if ((event.ctrlKey || event.altKey) && event.key === 'Enter') {
      if (this.readOnly) {
        return;
      }
      event.preventDefault();
      this.facade.addItem('WEB_BANNER');
      this.focusUbicacion(index + 1);
    }
  }

  handleEnterAdvance(event: Event, itemGroup: FormGroup, controlName: string): void {
    if (!(event instanceof KeyboardEvent) || event.key !== 'Enter') {
      return;
    }
    const control = itemGroup.get(controlName);
    if (control?.invalid) {
      return;
    }
    event.preventDefault();
    this.focusNextField(event);
  }

  confirmRemove(itemGroup: FormGroup, index: number): void {
    const shouldConfirm = this.facade.shouldConfirmDelete(itemGroup, 'WEB_BANNER');
    if (!shouldConfirm || window.confirm('¿Eliminar ítem de Banner Web?')) {
      this.facade.removeItem(index);
    }
  }

  openPricingDetail(itemGroup: FormGroup): void {
    this.selectedTrace = itemGroup.get('pricingTrace')?.value ?? null;
    this.pricingDialogVisible = true;
  }

  resetManualSubtotal(itemGroup: FormGroup): void {
    itemGroup.patchValue({ subtotalManual: null });
  }

  focusUbicacion(index: number): void {
    setTimeout(() => {
      const input = document.getElementById(`web-item-ubicacion-${index}`);
      if (input) {
        input.focus();
      }
    }, 0);
  }

  private focusNextField(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;
    const row = target?.closest('.item-row');
    if (!row) {
      return;
    }
    const focusables = Array.from(row.querySelectorAll<HTMLElement>(
      'input,button,textarea,select,[tabindex]:not([tabindex="-1"])'
    ));
    const index = focusables.indexOf(target as HTMLElement);
    const next = focusables[index + 1];
    if (next) {
      next.focus();
    }
  }
}
